// Amazon's legacy Shopify adapter follows variants but not this form's quantity.
// Use its existing public updateWidget API; do not create a second cart or checkout.
(() => {
  const root = document.querySelector('[data-yl-product-root]');
  const control = root?.querySelector('[data-yl-prime-control]');
  if (!control || control.dataset.ready) return;
  control.dataset.ready = 'true';
  const variants = JSON.parse(root.querySelector('[data-yl-product-json]').textContent).variants;
  const variantInput = root.querySelector('[name="id"]');
  const quantityInput = root.querySelector('[name="quantity"]');
  const status = root.querySelector('[data-yl-prime-status]');
  const skus = variants.map(variant => variant.sku).filter(Boolean);
  const sync = () => {
    const variant = variants.find(item => String(item.id) === variantInput.value);
    const quantity = Number(quantityInput.value);
    const valid = Number.isInteger(quantity) && quantity > 0 && quantityInput.checkValidity();
    control.inert = !valid;
    control.hidden = !variant?.sku;
    status.hidden = valid;
    status.textContent = valid ? '' : quantityInput.validationMessage || 'Enter a whole-number quantity of at least 1.';
    if (!valid || !variant?.sku || !control.querySelector('#bwpFrame')) return;
    // The asynchronously loaded provider may not be ready yet. The frame's load
    // event retries with the latest selection, including edits made while loading.
    if (typeof window.bwp?.updateWidget === 'function') {
      window.bwp.updateWidget(variant.sku, quantity, skus);
    }
  };
  let frame;
  const watchFrame = () => {
    const next = control.querySelector('#bwpFrame');
    if (next === frame) return;
    frame = next;
    if (frame) frame.addEventListener('load', sync);
    sync();
  };
  const observer = new MutationObserver(watchFrame);
  observer.observe(control, { childList: true, subtree: true });
  variantInput.addEventListener('change', sync);
  quantityInput.addEventListener('input', sync);
  quantityInput.addEventListener('change', sync);
  window.addEventListener('load', sync, { once: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  watchFrame();
  sync();
})();
